import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#697077",
      d: "m9.5 6.099-.012-.615a.58.58 0 0 0-.042-.21.5.5 0 0 0-.219-.218.554.554 0 0 0-.21-.043C8.875 5 8.688 5 8.4 5H3.6l-.616.012a.57.57 0 0 0-.211.042.5.5 0 0 0-.218.218.57.57 0 0 0-.042.211A8.47 8.47 0 0 0 2.5 6.1v2.8l.012.616a.57.57 0 0 0 .042.211.5.5 0 0 0 .218.219.563.563 0 0 0 .21.042c.141.012.328.012.615.012H8.4l.615-.012a.57.57 0 0 0 .21-.042.5.5 0 0 0 .219-.219.563.563 0 0 0 .042-.21c.012-.141.012-.327.012-.615V6.099zM7 3a1 1 0 1 0-2 0v1h2V3zm1 1h.4l.698.015c.198.016.394.052.583.148a1.5 1.5 0 0 1 .656.655c.096.189.132.386.149.583.016.192.015.426.015.697v2.803l-.015.696a1.515 1.515 0 0 1-.149.583 1.5 1.5 0 0 1-.656.655 1.552 1.552 0 0 1-.583.149c-.192.016-.425.015-.696.015H3.599c-.271 0-.505.001-.697-.015a1.515 1.515 0 0 1-.583-.149 1.5 1.5 0 0 1-.655-.655 1.532 1.532 0 0 1-.148-.584c-.016-.192-.015-.426-.015-.698V6.1l.015-.698c.016-.198.052-.394.148-.583a1.5 1.5 0 0 1 .655-.655c.189-.096.386-.132.584-.148C3.094 3.999 3.328 4 3.6 4H4V3a2 2 0 1 1 4 0v1z"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "lock"}) } }